import { queryOptions } from "@tanstack/react-query";
import { api, unwrap } from "@/shared/lib/apiClient";
import { patchKeys } from "@/shared/lib/queryKeys";

export const patchesQueryOptions = queryOptions({
  queryKey: patchKeys.all,
  queryFn: async () => unwrap(await api.GET("/api/patches")),
});
